import { format, setMonth } from 'date-fns';
import sv from 'date-fns/locale/sv';
import nb from 'date-fns/locale/nb';
import da from 'date-fns/locale/da';
import fi from 'date-fns/locale/fi';

const getLocale = (siteId) => {
  switch (parseInt(siteId, 10)) {
    case 1:
      return sv;
    case 3:
      return nb;
    case 11:
      return da;
    case 15:
      return fi;
    case 18:
      return sv;
    default:
      return sv;
  }
};

const getMonthName = (index, siteId) => {
  return format(setMonth(new Date(), index), 'MMMM', { locale: getLocale(siteId) });
};

export {
  getLocale,
  getMonthName,
};
